import { Component, OnInit, inject } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { SettingsService } from '@core';
// v16 exportiert MatDatetimepickerType nicht mehr oeffentlich -> lokaler Alias
type MatDatetimepickerType = 'date' | 'time' | 'month' | 'year' | 'datetime';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import moment from 'moment';

@Component({
  selector: 'formly-field-datpicker',
  template: `<mat-form-field appearance="outline" class="w-full">
    <mat-label [innerHtml]="field.templateOptions?.label"></mat-label>
    <mat-datetimepicker-toggle [for]="thePicker" matSuffix></mat-datetimepicker-toggle>

    <mat-datetimepicker
      #thePicker
      [type]="gettype()"
      [openOnFocus]="true"
      [startView]="field.templateOptions?.startView"
      [startAt]="field.templateOptions?.startAt"
      [lang]="lang"
    >
    </mat-datetimepicker>
    @if (formControl.errors?.matDatepickerMin) {
      <mat-error>
        <span [innerText]="field.templateOptions?.errorMessageMin | translate"></span>
      </mat-error>
    }
    @if (formControl.errors?.matDatepickerMax) {
      <mat-error>
        <span [innerText]="field.templateOptions?.errorMessageMax | translate"></span>
      </mat-error>
    }
    @if (formControl.errors?.matDatepickerParse) {
      <mat-error>
        <span [innerText]="'formErrors.datepicker.matDatepickerParse' | translate"></span>
      </mat-error>
    }
    <mat-error>
      <formly-validation-message [field]="field"></formly-validation-message>
    </mat-error>
    <input
      [title]="to.label"
      matInput
      [matDatetimepicker]="thePicker"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [matDatepickerFilter]="matDatepickerFilter"
      [min]="field.templateOptions?.minDate"
      [max]="field.templateOptions?.maxDate"
      (ngModelChange)="emitChange($event)"
      (click)="thePicker.open()"
      [required]="this.templateOptions?.required === true"
      readonly
  /></mat-form-field>`,
  standalone: false,
})
export class FormlyDatePickerComponent extends FieldType implements OnInit {
  private dateAdapter = inject<DateAdapter<Date>>(DateAdapter);
  private settingService = inject(SettingsService);

  field: FormlyFieldConfig;

  templateOptions: any;

  lang: string;

  matDatepickerFilter: (any) => any;

  constructor() {
    super();
    this.lang = this.settingService.language.substring(0, 2);
    this.dateAdapter.setLocale(this.settingService.language.substring(0, 2));
  }

  ngOnInit() {
    this.templateOptions = this.field.templateOptions;

    if (this.templateOptions?.dateFilter) {
      this.matDatepickerFilter = this.templateOptions?.dateFilter;
    } else if (this.templateOptions?.allowedDates) {
      this.matDatepickerFilter = (d: moment.Moment) => {
        if (d) {
          const day = d.format('DD.MM.YYYY');
          return this.templateOptions?.allowedDates.includes(day);
        }
        return true;
      };
    }
  }

  gettype() {
    return <MatDatetimepickerType>this.to.datetype || 'date';
  }

  emitChange(ev) {
    this.field.templateOptions?.change?.call(this.field, ev);
  }
}
